import request from '../utils/request'

// 企业库列表
export const companyList = (data) => {
    return request({
        url: '/buyer/usercompany/list',
        method: 'POST',
        data
    })
}
// 企业详情
export const companyDetail = (params) => {
    return request({
        url: '/buyer/usercompany/detail',
        method: 'GET',
        params
    })
}
// 地址
export const addressAll = () => {
    return request({
        url: '/common/address/listall',
        method: 'GET'
    })
}
// 获取车型车系
export function findChildsByKey(params) {
    return request({
        url: '/common/sysDict/findChildsByKey',
        method: 'get',
        params
    })
}
// 获取车型车系
export function homePageBanner(data) {
    return request({
        url: '/common/banner/homePageBanner',
        method: 'post',
        data
    })
}
// 获取车型车系
export function cartSave(data) {
    return request({
        url: '/buyer/cart/cart/save',
        method: 'post',
        data
    })
}
// 获取企业指数

export function company_point(data) {
    return request({
        url: '/xcx/usercompany/point',
        method: 'post',
        data
    })
}